import { css } from '@styled-system/css';
import type { FC } from 'react';

import { Logo, type LogoVariant } from './Logo';

interface NavItemProps {
  icon: LogoVariant;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}

export const NavItem: FC<NavItemProps> = ({ icon, label, isActive = false, onClick }) => {
  const itemStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: 'xs',
    px: '0.3125rem',
    h: '1.8125rem',
    alignSelf: 'stretch',
    borderRadius: isActive ? 'md' : 0,
    bg: isActive ? 'bg.selected' : 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
    _hover: {
      borderRadius: 'md',
      bg: 'bg.selected',
    },
  });

  const iconStyles = css({
    width: '1rem',
    height: '1.5rem',
  });

  const labelStyles = css({
    fontSize: 'md',
    fontWeight: 500,
    color: 'font.primary',
  });

  return (
    <div className={itemStyles} onClick={onClick}>
      <Logo variant={icon} className={iconStyles} />
      <span className={labelStyles}>{label}</span>
    </div>
  );
};
